import { t } from "@lingui/core/macro";
import type { OfferedCommitmentPlan } from "./commitmentPlanChoice";

export type SignCommitmentContext = {
  commitmentsEnabled: boolean;
  isRecurring: boolean;
  isCofunded: boolean;
  isTermRunning: boolean;
  isBilling: boolean;
  isPackageOffered: boolean;
};

/** Why signing is closed, in the operator's words; null when it is open. */
export function signCommitmentBlockedReason(
  context: SignCommitmentContext,
): string | null {
  if (!context.commitmentsEnabled) {
    return t`Vezave niso vklopljene.`;
  }
  if (!context.isBilling) {
    return t`Vezave ni mogoče skleniti na paketu, ki se ne obračunava več.`;
  }
  if (!context.isPackageOffered) {
    return t`Paket ni več v prodaji, zato nanj ni mogoče skleniti vezave.`;
  }
  if (!context.isRecurring) {
    return t`Vezavo je mogoče skleniti samo na ponavljajočem paketu.`;
  }
  if (context.isCofunded) {
    return t`Vezave ni mogoče skleniti, kadar del plačuje podjetje.`;
  }
  if (context.isTermRunning) {
    return t`Paket je že v vezavi. Novo vezavo je mogoče skleniti, ko se trenutna izteče.`;
  }
  return null;
}

/** The plans a running package can still sign; none of them while anything blocks signing. */
export function signableCommitmentPlans(
  plans: OfferedCommitmentPlan[] | undefined,
  context: SignCommitmentContext,
): OfferedCommitmentPlan[] {
  return signCommitmentBlockedReason(context) == null ? (plans ?? []) : [];
}
